//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import cmFooter from '@/components/cmFooter.vue'
export default {
  name: 'factory',
  components: {
      cmFooter
  },
  data () {
    return {
      info:{},
      nav:[
          {
          title:'入厂',
          path:'/inFactory/0',
          auth:'inFactory',
          img:'/static/images/inFactory.png',
        },
         {
          title:'打包',
          path:'/inFactory/1',
          auth:'pack',
          img:'/static/images/pack.png',
        },
         {
          title:'出厂',
          path:'/inFactory/2',
          auth:'outMaxFactory',
          img:'/static/images/outMaxFactory.png',
        },
       
        {
          title:'不洗退回',
          path:'/factoryReturn',
          auth:'factoryReturn',
          img:'/static/images/factoryReturn.png',
        },
        {
          title:'异常报备',
          path:'/abnormal',
          auth:'abnormal',
          img:'/static/images/abnormal.png',
        },
        {
          title:'厂内返洗',
          path:'/factoryBack',
          auth:'factoryBack',
          img:'/static/images/factoryBack.png',
        },
        {
          title:'污渍终结',
          path:'/stainsEnd',
          auth:'stainsEnd',
          img:'/static/images/stainsEnd.png',
        },
        {
          title:'衣物确认',
          path:'/clothesFactoryConfirm',
          auth:'clothesFactoryConfirm',
          img:'/static/images/status1.png',
        },
        {
          title:'衣物熨烫',
          path:'/ironing',
          auth:'ironing',
          img:'/static/images/ironing.png',
        },
        {
          title:'成品出厂',
          path:'/finisheOutFactory',
          auth:'finisheOutFactory',
          img:'/static/images/finisheOutFactory.png',
        },
        {
          title:'厂外反洗',
          path:'/factoryStoreBack',
          auth:'factoryStoreBack',
          img:'/static/images/worked.png',
        },
        {
          title:'掉签衣物',
          path:'/lostCode',
          auth:'lostCode',
          img:'/static/images/lostCode.png',
        },
        {
          title:'物流订单',
          path:'/waybillOrder',
          auth:'waybillOrder',
          img:'/static/images/express.png',
        },
      ],
      nav1:[
        {
          title:'衣物查询',
          path:'/clothesSearch',
          auth:'clothesSearch',
          img:'/static/images/clothesSearch.png',
        },
        {
          title:'条码查询',
          path:'/barOrder',
          auth:'barOrder',
          img:'/static/images/bar.png',
        },
        {
          title:'订单查询',
          path:'/searchOrder',
          auth:'searchOrder',
          img:'/static/images/searchOrder.png',
        },
      ]
    }
  },
  created(){
    if(this.$func.getLocal('token')){
      this.getCount();
    }else{
      this.$router.push({path:'/login'})
    }
  },
  mounted(){
  },
  methods:{
    getCount(){
      this.$api.factoryData({}).then((res)=>{
        this.info = res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/factory.vue